import { Label, cad } from "@/components/sponsored/format";

export function KpiStrip({ k }) {
  const tiles = [
    ["Eligible shoppers", k.funnel.eligible, "Made a first verified sale", "eligible"],
    ["Tapped Shop Again", k.funnel.activated, "Budget set aside for them", "activated"],
    ["Repeat purchases", k.funnel.repeat_purchases, `${k.repeat_rate_pct}% of eligible shoppers`, "repeat"],
    ["Repeat revenue", cad(k.repeat_revenue_cad), "Verified repeat sales", "revenue"],
    ["You funded", cad(k.sponsored_cashback_cad), "Bonus cashback on repeat sales", "sponsored"],
    ["Cyannect funded", cad(k.cyannect_base_cashback_cad), "Base cashback on the same sales", "base"],
  ];
  return (
    <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-6 gap-3" data-testid="sc-kpis">
      {tiles.map(([label, value, hint, t], i) => (
        <div key={t} className="pf-card p-4 animate-in fade-in slide-in-from-bottom-2 duration-500" style={{ animationDelay: `${i * 60}ms`, animationFillMode: "both" }} data-testid={`sc-kpi-${t}`}>
          <Label>{label}</Label>
          <div className="font-display text-2xl font-medium tabular-nums mt-2 text-slate-900">{value}</div>
          <div className="text-[11px] text-slate-500 mt-1">{hint}</div>
        </div>
      ))}
    </div>
  );
}
